export default __webpack_public_path__ + "static/media/mehreIran.51942514.jpg";